namespace GeniuzPOS.PriceChange {
    export enum ApproveFgSelect {
        ApproveFgSelect = 0,
        ApproveFgSelect1 = 1,
        WaitFgSelect1 = 2
    }
    Serenity.Decorators.registerEnumType(ApproveFgSelect, 'GeniuzPOS.PriceChange.ApproveFgSelect', 'PriceChange.ApproveFgSelect');
}
